import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";
import { useWorkspace } from "./WorkspaceContext";

const ClassesContext = createContext(null);

export function ClassesProvider({ children }) {
  const { current } = useWorkspace();
  const [classes, setClasses] = useState([]);
  const [activeClassId, setActiveClassId] = useState(null);

  const load = useCallback(async () => {
    if (!current) return setClasses([]);
    const { data } = await api.get(`/workspaces/${current.workspace_id}/classes`);
    setClasses(data);
  }, [current]);

  useEffect(() => { load(); setActiveClassId(null); }, [load]);

  const create = async (body) => {
    const { data } = await api.post(`/workspaces/${current.workspace_id}/classes`, body);
    setClasses((prev) => [...prev, data]);
    return data;
  };
  const update = async (class_id, body) => {
    const { data } = await api.put(`/workspaces/${current.workspace_id}/classes/${class_id}`, body);
    setClasses((prev) => prev.map((c) => c.class_id === class_id ? data : c));
    return data;
  };
  const remove = async (class_id) => {
    await api.delete(`/workspaces/${current.workspace_id}/classes/${class_id}`);
    setClasses((prev) => prev.filter((c) => c.class_id !== class_id));
    if (activeClassId === class_id) setActiveClassId(null);
  };

  const activeClass = classes.find((c) => c.class_id === activeClassId) || null;
  const classByName = (name) => classes.find((c) => c.name === name);

  return (
    <ClassesContext.Provider value={{ classes, setClasses, create, update, remove, activeClassId, setActiveClassId, activeClass, classByName, reload: load }}>
      {children}
    </ClassesContext.Provider>
  );
}

export const useClasses = () => useContext(ClassesContext);
